import magnificPopup from 'magnific-popup';

var jsModalIframe = jQuery('.js-modal-iframe');
var jsModalInline = jQuery('.js-modal-inline');

if (jsModalIframe.length) {
	jsModalIframe.each(function () {
		jQuery(this).magnificPopup({
			type: 'iframe',
		})
	})
}

if (jsModalInline.length) {
	jsModalInline.each(function () {
		jQuery(this).magnificPopup({
			type: 'inline',
			removalDelay: 200,
			callbacks: {
				beforeOpen: function() {
				this.st.mainClass = 'mfp-zoom-in';
				}
			},
		})
	})
}